import { h } from "@stencil/core";
import { TableCellProps } from "../table-cell";

export const renderText = ({
    schemaItem,
    item,
    columnKey,
    translate,
}: TableCellProps) => {
    const translationKey = `${columnKey}.values.${item[columnKey]}`;
    const translated = translate(translationKey);
    return (
        <td class={schemaItem.className} data-testid={columnKey}>
            {translated !== translationKey ? translated : item[columnKey]}
        </td>
    );
};
